<template>
    <AppSeoTags>
        <title>Tyre Brands</title>

        <link head-key="canonical" rel="canonical" :href="route('brands.index')">
    </AppSeoTags>

    <AppJumbotron>
        <div class="max-w-screen-md">
            <h1 class="text-white mb-8 text-3xl md:text-5xl tracking-wide">
                Find reviews by <span class="font-bold">tyre brand</span> at {{ config.name }}
            </h1>

            <p class="text-white mb-8">
                To help you choose your next set of tyres, we have pulled together tyre information and customer
                reviews, grouped by tyre brand. Within each brand's section on our site, you will find the
                most popular tyres fitted by our customers - as well as their thoughts and reviews on the tyres.
            </p>

            <div class="md:max-w-xs">
                <form @submit.prevent="form.get(route('brands.index'), {
                    preserveScroll: true
                })">
                    <AppSearchBar v-model="form.search"
                                  placeholder="Find a brand or tyre..."></AppSearchBar>
                </form>
            </div>
        </div>
    </AppJumbotron>

    <AppContainer>
        <h3 class="text-dark mt-8 mb-4 text-2xl md:text-3xl">
            Find tyres for the
            <span class="font-bold">most popular tyre brands</span>
        </h3>

        <p class="text-dark mb-12">Use the list below to explore tyre brands</p>

        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"
             v-if="brands.length > 0">
            <BrandCard v-for="brand of brands" :brand="brand"></BrandCard>
        </div>

        <AppAlert v-else type="error" key="form-error">
            We couldn't find any vehicles for your search.
        </AppAlert>
    </AppContainer>
</template>

<script>
import AppAlert from "@/Components/AppAlert";
import AppContainer from "@/Layouts/AppContainer";
import AppJumbotron from "@/Components/AppJumbotron";
import AppSearchBar from "@/Components/AppSearchBar";
import {Head, useForm} from "@inertiajs/inertia-vue3";
import BrandCard from "@/Components/Brands/BrandCard";
import AppSeoTags from "@/Components/AppSeoTags";

export default {
    components: {AppSeoTags, BrandCard, AppAlert, AppContainer, AppJumbotron, AppSearchBar, Head},
    props: {
        brands: Array,
        search: String,
        config: Object
    },
    data() {
        return {
            form: useForm({
                search: this.search
            })
        };
    },
};
</script>

<style scoped>

</style>
